import { setupReceiptTargetedUploadListener } from 'app-components/store/listeners';

import { receiptUploadCoordinator } from 'containers/ReceiptCenter/receiptUploadCoordinator';

import { startAppListening } from '../listenerMiddleware';

setupReceiptTargetedUploadListener(startAppListening, {
  getActiveUploadIds: () => receiptUploadCoordinator.getActiveUploadIds(),
});
